import React from 'react';
import logo from '../../../../images/27crags_symbol_flat.png';

const AppBanner = ({ appLink }) => {
  if (!appLink) return null;

  return (
    <div className="open-in-app-container">
      <input
        type="checkbox"
        id="close-deep-link-banner"
        className="open-in-app-toggle"
        hidden
      />
      <div className="open-in-app-banner">
        <div className="banner-content">
          <label
            htmlFor="close-deep-link-banner"
            className="dismiss-button"
            aria-label="Dismiss"
          >
            ✕
          </label>
          <img src={logo} alt="27 Crags Logo" className="app-logo" />
          <div className="text">
            <h4>27 Crags</h4>
            <p>Continue in our app</p>
          </div>
          <a
            href={appLink}
            className="open-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Use App
          </a>
        </div>
      </div>
    </div>
  );
};

export default AppBanner;

